import React from 'react';
import { motion } from 'framer-motion';
import { Layout } from '../components/Layout';
import { Showroom } from '../components/Showroom';
const PROJECTS = [{
  title: 'Traditional Oak Reface',
  location: 'Bethesda, MD',
  image: 'https://cdn.magicpatterns.com/uploads/fZacsfF1XsKzt9rhx3HW2f/b-1.jpg'
}, {
  title: 'Modern Kitchen Update',
  location: 'Arlington, VA',
  image: 'https://cdn.magicpatterns.com/uploads/jSif27kDeCfjpi6GVtuyf2/b-2.jpg'
}, {
  title: 'Classic Cabinet Refinish',
  location: 'Potomac, MD',
  image: 'https://cdn.magicpatterns.com/uploads/v1Qn8imjfgNzCQUpAGimmM/b-3.jpg'
}, {
  title: 'Vintage Wood Restoration',
  location: 'Silver Spring, MD',
  image: 'https://cdn.magicpatterns.com/uploads/tfJ5piQs4i3CyZKkHGeSNj/b-4.jpg'
}, {
  title: 'Rustic Kitchen Remodel',
  location: 'Bowie, MD',
  image: 'https://cdn.magicpatterns.com/uploads/iXZhiea3EJJkBE99fJvRUh/b-5.jpg'
}];
const FINISHES = [{
  name: 'Espresso Wood',
  image: 'https://cdn.magicpatterns.com/uploads/pEXjvtTErJLYHHVGzdMZH1/pexels-karola-g-4022121.jpg'
}, {
  name: 'Matte Charcoal',
  image: 'https://cdn.magicpatterns.com/uploads/eAMivg3Gqj5ubm5sXciJeb/pexels-eva-bronzini-7599717.jpg'
}, {
  name: 'Copper Brown',
  image: 'https://cdn.magicpatterns.com/uploads/3feup6JNNa1Yk6uDDpreEf/pexels-athena-1567356_(1).jpg'
}, {
  name: 'Alabaster White',
  image: 'https://cdn.magicpatterns.com/uploads/piVdpzp8WxYkgo6Q489yTx/pexels-artbovich-7746586.jpg'
}, {
  name: 'Midnight Oak',
  image: 'https://cdn.magicpatterns.com/uploads/89D7jsPDqRGdKWyCRFUZ1j/pexels-share-textures-3167406-11285434.jpg'
}, {
  name: 'Natural Walnut',
  image: 'https://cdn.magicpatterns.com/uploads/cXS5gck7dhTdnhLYXD18AD/pexels-tihomir-trifonov-3106425-5225594.jpg'
}, {
  name: 'Slate Grey',
  image: 'https://cdn.magicpatterns.com/uploads/crRVcjtAerurbP1wWaLjGU/pexels-hngstrm-7466411.jpg'
}, {
  name: 'Classic Cream',
  image: 'https://cdn.magicpatterns.com/uploads/bfXR47xZi2aHgJ7DYFq42F/pexels-eva-bronzini-7956853.jpg'
}];
export function ShowroomPage() {
  return <Layout data-id="element-569">
      {/* Hero Section */}
      <section className="relative h-[40vh] md:h-[50vh] flex items-center justify-center overflow-hidden border-b-3 border-[#6B0D24]" data-id="element-570">
        <div className="absolute inset-0 z-0" data-id="element-571">
          <img src="https://cdn.magicpatterns.com/uploads/bd3BfChmz2XCxZc9gcWLVc/image.png" alt="Showroom Background" className="w-full h-full object-cover brightness-[0.4]" data-id="element-572" />
          <div className="absolute inset-0 bg-black/50" data-id="element-573" />
        </div>

        <div className="max-w-7xl mx-auto w-full px-6 relative z-10" data-id="element-574">
          <motion.span initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} className="inline-block text-[#C41E3A] font-black uppercase tracking-[0.3em] text-xs mb-6 drop-shadow-md" data-id="element-575">
            Design Inspiration
          </motion.span>
          <motion.h1 initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.1
        }} className="text-4xl md:text-6xl font-bold mb-8 uppercase tracking-tighter text-white drop-shadow-lg" data-id="element-576">
            The <span className="text-[#C41E3A]" data-id="element-577">Showroom</span>
          </motion.h1>
          <p className="text-xl text-white/90 max-w-2xl leading-relaxed drop-shadow-sm" data-id="element-578">
            Explore our curated collection of door styles, finishes, and recent
            transformations. Every piece is precision-crafted to meet the
            highest standards of modern luxury.
          </p>
        </div>
      </section>

      {/* Recent Transformations Section - Using Homepage Project Images */}
      <section className="py-24 px-6 bg-white" data-id="element-579">
        <div className="max-w-7xl mx-auto" data-id="element-580">
          <div className="text-center mb-16 space-y-3" data-id="element-581">
            <span className="text-[#6B0D24] font-black uppercase tracking-[0.3em] text-[10px]" data-id="element-582">
              Portfolio
            </span>
            <h2 className="text-4xl md:text-6xl font-black text-charcoal uppercase tracking-tight" data-id="element-583">
              Recent Transformations
            </h2>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-584">
            {PROJECTS.map((project, idx) => <motion.div key={idx} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: idx * 0.1
          }} className="group relative h-[500px] overflow-hidden border border-charcoal/5" data-id="element-585">
                <img src={project.image} alt={project.title} className="w-full h-full object-cover transition-transform duration-1000 group-hover:scale-110" data-id="element-586" />
                <div className="absolute inset-0 bg-gradient-to-t from-black/90 via-black/20 to-transparent" data-id="element-587" />

                <div className="absolute bottom-0 left-0 w-full p-10 space-y-2" data-id="element-588">
                  <p className="text-[#6B0D24] text-[10px] font-black uppercase tracking-[0.3em]" data-id="element-589">
                    {project.location}
                  </p>
                  <h3 className="text-2xl font-black text-white uppercase tracking-tight leading-none" data-id="element-590">
                    {project.title}
                  </h3>
                </div>
              </motion.div>)}
          </div>
        </div>
      </section>

      {/* Materials & Door Styles */}
      <Showroom data-id="element-591" />

      {/* Premium Finishes Section */}
      <section className="py-24 px-6 bg-alabaster border-t-3 border-charcoal" data-id="element-592">
        <div className="max-w-7xl mx-auto" data-id="element-593">
          <div className="mb-12" data-id="element-594">
            <h2 className="text-4xl font-black text-charcoal uppercase tracking-tight" data-id="element-595">
              Premium Finishes
            </h2>
            <div className="w-20 h-2 bg-[#6B0D24] mt-4" data-id="element-596" />
          </div>

          <div className="grid grid-cols-2 md:grid-cols-4 gap-8" data-id="element-597">
            {FINISHES.map((finish, idx) => <motion.div key={finish.name} initial={{
            opacity: 0
          }} whileInView={{
            opacity: 1
          }} viewport={{
            once: true
          }} transition={{
            delay: idx * 0.05
          }} className="group cursor-pointer" data-id="element-598">
                <div className="aspect-square border-3 border-charcoal mb-4 overflow-hidden bg-charcoal/10" data-id="element-599">
                  <img src={finish.image} alt={finish.name} className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-700" data-id="element-600" />
                </div>
                <p className="font-black uppercase tracking-widest text-[10px] text-charcoal/60 group-hover:text-[#6B0D24] transition-colors" data-id="element-601">
                  {finish.name}
                </p>
              </motion.div>)}
          </div>
        </div>
      </section>
    </Layout>;
}